import MuiCard from "@mui/material/Card";

/**
 * Facade over MUI Card. Customize defaults here.
 */
export default function Card(props) {
  return <MuiCard {...props} />;
}
